import type {
  RichTextTextAnimation,
  RichTextTextAnimationWithElement,
} from "@library-elements/text";
import {
  COMBO_ANIM_BASE_OPACITY,
  COMBO_ANIM_DEFAULT_SPEED,
} from "@library/constants";

export const getTextAnimationsInSelection = (
  editor: any,
): RichTextTextAnimationWithElement[] => {
  const sel = window.getSelection();
  if (!sel) return [];
  const anims: RichTextTextAnimationWithElement[] = [];
  const blocks = editor.selection.blocks() as HTMLElement[];

  blocks.forEach((b) => {
    if (sel.containsNode(b, true) && isTextAnimationElement(b)) {
      const data = getTextAnimationDataFromEl(b);
      anims.push({
        speed: data.speed,
        baseOpacity: data.baseOpacity,
        element: b,
      });
    }
  });

  return anims;
};

export const getTextAnimationDataFromEl = (
  el: HTMLElement,
): RichTextTextAnimation => {
  const speed =
    el.getAttribute("data-text-animation-speed") ?? COMBO_ANIM_DEFAULT_SPEED;
  const baseOpacity =
    el.getAttribute("data-text-animation-base-opacity") ??
    (Number(COMBO_ANIM_BASE_OPACITY) / 100).toString();

  return {
    speed,
    baseOpacity,
  };
};

export const deactivateAllTextAnimations = (tree = document) => {
  const textAnims = tree.querySelectorAll("[data-text-animation-active]");
  textAnims.forEach((h) => {
    h.setAttribute("data-text-animation-active", "false");
  });
};

export const isTextAnimationElement = (el: HTMLElement) =>
  el.getAttribute("data-text-animation-active");

export const textAnimationStart = (el: Element) => {
  el.setAttribute("data-text-animation-active", "true");
};

export const removeTextAnimationAttrs = (el: HTMLElement) => {
  el.removeAttribute("data-text-animation-active");
  el.removeAttribute("data-text-animation-speed");
  el.removeAttribute("data-text-animation-base-opacity");
  el.style.removeProperty("opacity");
};

export const setTextAnimationAttrs = (
  el: HTMLElement,
  data: RichTextTextAnimation,
) => {
  el.setAttribute("data-text-animation-active", "true");
  el.setAttribute("data-text-animation-speed", data.speed);
  el.setAttribute("data-text-animation-base-opacity", data.baseOpacity);
  el.style.setProperty("opacity", data.baseOpacity);
};
